import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PrescricaoTemplate } from '../models/prescricao-template.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrescricaoTemplateService {
  // A rota base agora é a do MedicoController
  private apiUrl = `${environment.apiUrl}medico`; 

  constructor(private http: HttpClient) { }

  getTemplatesDoMedico(numConselho: string): Observable<any> {
    // Rota: api/v1/medico/getprescricaotemplate/{numConselho}
    return this.http.get<any>(`${this.apiUrl}/getprescricaotemplate/${numConselho}`);
  }

  salvarTemplate(template: PrescricaoTemplate): Observable<any> {
    // Rota: api/v1/medico/createtemplate
    return this.http.post<any>(`${this.apiUrl}/createtemplate`, template);
  }

  excluirTemplate(id: number): Observable<any> {    
    return this.http.delete<any>(`${this.apiUrl}/deletetemplete/${id}`);
  }
  
    atualizarTemplate(template: PrescricaoTemplate): Observable<any> {    
    return this.http.put<any>(`${this.apiUrl}/updatetemplate`, template);
    }
}